<template>
    <div class="panel" id="panel" ref="panel"></div>
</template>

<script>
/* eslint-disable */
export default {
    data() {
        return {
            
        }
    },
    props: {
        panelData: String
    },
    watch: {
        panelData: function () {
            this.initChart()
        }
    },
    mounted() {
        this.initChart();
        // console.log(this.panelData);
    },
    methods: {
        // 初始化图表
        initChart() {
            // var panel_node = document.getElementById('panel');
            var panel_node = this.$refs.panel
            var myEchart = this.$echarts.init(panel_node);
            var data = this.handleStr(this.panelData);
            var option = {
                grid:[{
                    left: '0%',
                    height: '75%'
                }],
                series: [
                    {
                        name: "白色圈刻度",
                        type: "gauge",
                        radius: "80%",
                        center: ["50%", "75%"],
                        startAngle: 180,//刻度起始
                        endAngle: 0,//刻度结束
                        z: 4,
                        axisTick: { show: false},
                        splitLine: {
                            length: 0,//刻度节点线长度
                            lineStyle: {width: 2,  color: 'rgba(0,0,0, 0.9)'}//刻度节点线
                        }, 
                        axisLabel: {color: '#',  fontSize: 10, show: false},//刻度节点文字颜色
                        pointer: {show: false },
                        axisLine: {
                            lineStyle: {opacity: 0}
                        },
                        detail: {show: false},
                        // data: [{value: 0,name: ""}]
                    }, {
                        name: '灰色内圈',//刻度背景
                        type: 'gauge',
                        z: 2,
                        radius: '100%',
                        startAngle: 180,
                        endAngle: 0,
                        splitNumber: 2 || 100,
                        min: -1,
                        max: 1,
                        center: ["50%", "75%"], //整体的位置设置
                        axisLine: { // 坐标轴线
                        /* lineStyle: { // 属性lineStyle控制线条样式
                                color: [ [1, 'rgba(51, 255, 255, 0.1)']],width: 15, opacity: 1,//刻度背景宽度
                            },*/
                            lineStyle: {
                                width: 5,
                                shadowBlur: 0,
                                color: [
                                    [0.2, '#5f5d5d'],
                                    [0.8, '#888888'],
                                    [1, '#5f5d5d']
                                ]
                            }
                        },
                        splitLine: {show: false},
                        data: [{show: false, value: '80'}],//作用不清楚
                        axisLabel: {
                            show: true,
                            fontSize: '12',
                            distance: -20,
                            formatter: function(e) {
                                switch (e + '') {
                                    case '-1':
                                        return '-';
                                    case '1':
                                        return '+';
                                    default:
                                        return '';
                                }
                            } 
                        },
                        pointer: {show: false},
                        axisTick: { show: false},
                        detail: {show: 0}
                    }, {
                        name: '指针',
                        type: 'gauge',
                        z: 6,
                        radius: '95%',
                        startAngle: 180,
                        endAngle: 0,
                        center: ["50%", "75%"], //整体的位置设置
                        axisLine: {
                        lineStyle: {// 属性lineStyle控制线条样式//指针颜色
                                color: [[1, '#A3DB41']],  width:0
                            }
                        },
                        axisTick: {show: false},
                        splitLine: { show: false},
                        axisLabel: {show: false},
                        data: [data.pos_value],//指针位置
                        pointer: { show: true, width: 2, length: '90%'},
                        detail: {show: 0}
                    }
                ]
            }

            myEchart.setOption(option)
        },

        // 值拆分
        handleStr(str) {
            if (!str) return {
                'pos_value': 50,
                'real_value': 0
            }
            if (str.includes('|')) {
                var str_list = str.split('|');
                var pos_value = (Number(str_list[0])+Number(str_list[1])) / 2
                var critical_data =  Number(str_list[2])
                var rate = Math.abs(pos_value/critical_data);
                if (pos_value < 0) {// 为负数
                    var r_deg = 50 - rate*30
                    return {
                        'pos_value': r_deg,
                        'real_value': pos_value,
                    }
                } else {
                    return {
                        'pos_value': 50 + rate*30,
                        'real_value': pos_value,
                    }
                }
                
            } else {
                return {
                    'pos_value': 50,
                    'real_value': 0
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .panel{
        width: 50px;
        height: 50px;
    }
</style>
